import type { SupportedLocale as Lang } from "@site-types/site"
import type { ReactNode } from "react"
import BackButtonComponent from "./BackButton"
import Background from "./Background"
import BigHeadingComponent from "./BigHeading"
import Footer from "./Footer"
import Main from "./Main"
import SideMenu from "./SideMenu"

type SiteShellProps = {
  children: ReactNode
  locale: Lang
  page: string
  title?: string
}

export function SiteShell({ children, locale, page, title }: SiteShellProps) {
  const pageClass = page.replace(/[^a-z0-9_-]/gi, "-")

  const content = (
    <>
      {title ? <BigHeadingComponent>{title}</BigHeadingComponent> : null}
      {children}
    </>
  )

  return (
    <div className="site-shell">
      <SideMenu
        locale={locale}
        page={page}
      />
      <Main>
        {page === "index" ? content : <div className={`page-container page-${pageClass}`}>{content}</div>}
        {page !== "index" ? <Footer /> : null}
      </Main>
      <Background />
    </div>
  )
}

export const BigHeading = BigHeadingComponent

export const BackButton = BackButtonComponent
